import { DecimalPipe } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { AiRunStep } from '../../core/models/ai.model';
import {
  durationMs,
  formatDuration,
  sortRunSteps,
  totalTokens,
} from '../../core/utils/ai-form.util';
import { AiStatusBadgeComponent } from '../../shared/ai-status-badge.component';

/** Timeline dos steps de uma execução, na ordem de `created_at` (chamado 0000579137). */
@Component({
  selector: 'ai-run-step-timeline',
  standalone: true,
  imports: [DecimalPipe, MarkdownModule, AiStatusBadgeComponent],
  templateUrl: './run-step-timeline.component.html',
  styleUrls: ['./run-step-timeline.component.scss'],
})
export class AiRunStepTimelineComponent {
  readonly steps = input<AiRunStep[] | null | undefined>([]);

  readonly ordered = computed(() => sortRunSteps(this.steps()));
  readonly expanded = signal<Set<number>>(new Set());

  readonly tokens = totalTokens;

  duration(step: AiRunStep): string {
    return formatDuration(step.duration ?? durationMs(step.started_at, step.finished_at));
  }

  hasDetails(step: AiRunStep): boolean {
    return !!(step.output || step.error);
  }

  toggle(index: number): void {
    this.expanded.update(current => {
      const next = new Set(current);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  }
}
